var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"additional-page"},[_c('ResumeForm',{ref:"form",attrs:{"formLine":_vm.formData,"data":_vm.data}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }